<template>
  <offer-sale-base :offer-sale="offerSale" :is-group="isGroup" type="offer_sales" :is-activable="isActivable">
    <template v-slot:line-1>
      <offer-sale-line :line-items="isGroup ? priceItems : productInfoItems" />
    </template>

    <template v-slot:line-2>
      <offer-sale-line :line-items="isGroup ? minMaxItems : priceItems">
        <user-consumption v-if="isGroup" :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="userSaleConsumptionAmountInGroup" />
      </offer-sale-line>
    </template>

    <template v-if="!isGroup" v-slot:line-3>
      <offer-sale-line :line-items="minMaxItems">
        <user-consumption :maximum-per-client="offerSale.maximum_per_client" :user-sale-consumption-amount="offerSale.user_sale_consumption_amount" />
      </offer-sale-line>
    </template>
  </offer-sale-base>
</template>

<script>
import OfferSaleBase from './OfferSaleBase.vue'
import OfferSaleLine from './OfferSaleLine.vue'
import UserConsumption from './UserConsumption.vue'

export default {
  name: 'GeneralOfferSale',
  components: {
    OfferSaleBase,
    OfferSaleLine,
    UserConsumption,
  },
  props: {
    offerSale: {
      type: Object,
      required: true,
    },
    hasSegments: {
      type: Boolean,
      default: false,
    },
    isActivable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isGroup() {
      return this.offerSale.offer_sales && this.offerSale.offer_sales.length > 0
    },
    userSaleConsumptionAmountInGroup() {
      return this.offerSale.offer_sales.reduce((acc, offerSale) => acc + offerSale.user_sale_consumption_amount, 0)
    },
    productInfoItems() {
      return [
        {
          label: 'SKU',
          value: this.offerSale.sku,
          format: 'text',
        },
        {
          label: 'EAN',
          value: this.offerSale.ean,
          format: 'text',
        },
      ]
    },
    priceItems() {
      return [
        {
          label: 'Preço 1',
          value: this.offerSale.price_1,
          format: 'currency',
        },
        {
          label: this.hasSegments ? 'Preço 3' : 'Preço 2',
          value: this.offerSale.price_2,
          format: 'currency',
        },
      ]
    },
    minMaxItems() {
      return [
        {
          label: 'Mín. CPF',
          value: this.offerSale.minimum_per_client,
          format: 'text',
        },
        {
          label: 'Máx. CPF',
          value: this.offerSale.maximum_per_client,
          format: 'text',
        },
      ]
    },
  },
}
</script>
